module.exports = __webpack_public_path__ + "img/称霸侏罗纪.7aaf8c3c.png";